import React from "react";
import personalData from "../config/personalData";

export default function EditorialCard({
  image,
  imageAlt,
  title,
  description,
  href,
  linkLabel,
  meta,
  tags,
  minimal,
  index = 0,
  textAnimationDelay,
  imageAnimationDelay,
}) {
  const { theme } = personalData;

  if (minimal) {
    const textDelay = textAnimationDelay ?? `${index * 0.12}s`;
    const imageDelay = imageAnimationDelay ?? `${index * 0.12 + 0.12}s`;

    return (
      <article className="w-full max-w-[260px]">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="minimal-link motion-fade-up mb-4 inline-flex text-sm lowercase tracking-[0.18em] transition-opacity duration-200 hover:opacity-70"
          style={{ color: theme.colors.accent, animationDelay: textDelay }}
        >
          <span>{linkLabel}</span>
          <span aria-hidden="true" className="minimal-link__icon text-xs">
            ↗
          </span>
        </a>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="editorial-frame motion-frame-reveal block border p-2"
          style={{ borderColor: theme.colors.border, animationDelay: imageDelay }}
        >
          <img
            src={image}
            alt={imageAlt}
            className="aspect-[4/5] w-full object-cover"
          />
        </a>
      </article>
    );
  }

  return (
    <article
      className="surface-card grid gap-6 border p-5 md:grid-cols-[180px_minmax(0,1fr)] md:gap-8 md:p-7"
      style={{
        backgroundColor: theme.colors.surface,
        borderColor: theme.colors.border,
      }}
    >
      <div
        className="editorial-frame motion-frame-reveal overflow-hidden border p-2"
        style={{
          borderColor: theme.colors.border,
          animationDelay: `${index * 0.12 + 0.08}s`,
        }}
      >
        <img
          src={image}
          alt={imageAlt}
          className="aspect-[4/5] w-full object-cover"
        />
      </div>

      <div
        className="motion-fade-up flex flex-col justify-between"
        style={{ animationDelay: `${index * 0.12}s` }}
      >
        <div>
          {meta ? (
            <p
              className="text-xs uppercase tracking-[0.35em]"
              style={{ color: theme.colors.accentSoft }}
            >
              {meta}
            </p>
          ) : null}
          <h2
            className="mt-3 font-bodoni text-3xl leading-tight md:text-4xl"
            style={{ color: theme.colors.accent }}
          >
            {title}
          </h2>
          {description ? <p className="mt-4 text-base leading-8">{description}</p> : null}
          {tags?.length ? (
            <div className="mt-5 flex flex-wrap gap-2">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="border px-3 py-1 text-[11px] uppercase tracking-[0.22em]"
                  style={{
                    borderColor: theme.colors.border,
                    color: theme.colors.muted,
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          ) : null}
        </div>

        <div className="mt-6">
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="minimal-link inline-flex pb-1 text-sm lowercase tracking-[0.18em] transition-opacity duration-200 hover:opacity-70"
            style={{ color: theme.colors.accent }}
          >
            <span>{linkLabel}.</span>
            <span aria-hidden="true" className="minimal-link__icon text-xs">
              ↗
            </span>
          </a>
        </div>
      </div>
    </article>
  );
}
